export class AppError extends Error {
  code: string
  status?: number
  cause?: unknown

  constructor(message: string, options?: { code?: string; status?: number; cause?: unknown }) {
    super(message)
    this.name = 'AppError'
    this.code = options?.code || 'APP_ERROR'
    this.status = options?.status
    this.cause = options?.cause
  }
}

export function toErrorMessage(error: unknown, fallbackMessage: string): string {
  if (error instanceof AppError) {
    return error.message || fallbackMessage
  }
  if (error instanceof Error) {
    return error.message || fallbackMessage
  }
  return fallbackMessage
}
